import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import check_mark from './imageFiles/check_mark.png';

const CheckMark = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={check_mark}
      style={{ width: '100%' }}
      alt="Check Mark Illustration"
    />
  </Box>
);
export default CheckMark;
